import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

import * as InternalToolsActions from './internal-tools.actions';

@Injectable()
export class InternalToolsEffects {
   constructor(private actions$: Actions) {}
}
